import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'tailwindcss/dist/tailwind.css';
import './style/index.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import Root from './Root';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Root />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
